import ReportSectionTitle from "../../../../components/common/ReportSectionTitle";
import DynamicFormHeaderForReport from "./DynamicFormHeaderForReport";

export default function ReportReviewForm({
  dynamicForm,
  eventId,
  original,
  hideSignatures,
  formResultsFormatting,
  hideModificationDate
}) {
  return (
    <div>
      <ReportSectionTitle title={dynamicForm.Name} />
      <DynamicFormHeaderForReport
        dynamicForm={dynamicForm}
        eventId={eventId}
        original={original}
        hideSignatures={hideSignatures}
        formResultsFormat={formResultsFormatting}
        hideModificationDate={hideModificationDate}
      />
    </div>
  );
}
